import type { IconProps } from './types/types';

const TicketCloseOutlined = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      {...svgProps}
    >
      <path d="M18.258 19.422C18.1294 19.5988 17.8682 19.5988 17.7397 19.422L10.5879 9.53811C10.4352 9.32516 10.5879 9.02784 10.849 9.02784H12.7334C13.1472 9.02784 13.533 9.22471 13.774 9.5582L18.0008 15.4002L22.2236 9.5582C22.4647 9.22471 22.8544 9.02784 23.2642 9.02784H25.1486C25.4097 9.02784 25.5624 9.32516 25.4097 9.53811L18.258 19.422Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.21491 1.9292H32.7863C33.4975 1.9292 34.0721 2.50375 34.0721 3.21491V32.7863C34.0721 33.4975 33.4975 34.0721 32.7863 34.0721H3.21491C2.50375 34.0721 1.9292 33.4975 1.9292 32.7863V3.21491C1.9292 2.50375 2.50375 1.9292 3.21491 1.9292ZM31.1792 22.019H24C23.9958 25.3292 21.3111 28.0112 18 28.0112C14.6889 28.0112 12.0043 25.3292 12 22.019H4.82206V4.82206H31.1792V22.019Z"
      />
    </svg>
  );
};
export default TicketCloseOutlined;
